// extracted by mini-css-extract-plugin
export default {"facets-menu":"facets-menu--BCgsb","facets-menu__facets":"facets-menu__facets--OKC2g"};